import React, {useState} from 'react';
import {Badge, Button, Card, CardActionArea, IconButton, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {DocumentInfo, filesService} from '@store/files';

import AlertComponent from '@components/modal/Alert.component';  

import {Close, File} from '@icons/index';
import {Colors} from '@constants/colors.constants';

interface FileCardProps {
  document: DocumentInfo;
  handleDeleteDocument?: () => void;
}

const FileCard = (props: FileCardProps) => {
  const {document, handleDeleteDocument} = props;

  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);

  const documentUrl = document.file ? URL.createObjectURL(document.file) : filesService.getDocumentUrl(document.id);

  return (
    <>
      <Badge
        componentsProps={{badge: {style: {right: 4, top: 4}}}}
        invisible={!handleDeleteDocument}
        badgeContent={(
          <IconButton onClick={() => setConfirmDelete(true)} aria-label="remove-document">
            <Close style={{color: Colors.white, height: 8, width: 8}}/>
          </IconButton>
        )}>
        <Card
          variant="document"
          color="secondary"
          component={CardActionArea}
          onClick={() => filesService.openUrlInNewTab(documentUrl)}>
          {document.mimetype.includes('image/') ? (
            <img
              alt={''}
              style={{maxHeight: '100%', maxWidth: '100%'}}
              src={documentUrl}/>
          ) : (
            <>
              <File/>
              <Stack mt="5px">
                <Typography
                  textAlign="center"
                  fontSize={10}
                  fontWeight="700"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                  }}>
                  {document.name}
                </Typography>
              </Stack>
            </>
          )}
        </Card>
      </Badge>
      {confirmDelete && (
        <AlertComponent
          title={t('delete.title')}
          aria-label="over-drawer"
          description={t('delete.description.document')}
          handleClose={() => setConfirmDelete(false)}
          actions={(
            <>
              <Button variant="outlined" color="primary" disabled={loading} onClick={() => setConfirmDelete(false)}>
                {t('global.cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                onClick={() => {
                  setLoading(true);
                  handleDeleteDocument?.();
                }}>
                {t('global.delete')}
              </Button>
            </>
          )}/>
      )}
    </>
  );
};

export default FileCard;
